export default [
	{
		id: 1,
		type: "text",
		title: "Persönliche Angaben",
		items: [
			{
				id: 1,
				type: "small",
				text: "Semester",
			},
			{
				id: 2,
				type: "medium",
				text: "Studiengang",
			},
		],
	},
	{
		id: 2,
		type: "matwis-p",
		title: "Wie bewerten Sie diese Veranstaltung (in Schulnoten)?",
		rowTitle: "Praktikumsversuch",
		items: [
			{
				id: 3,
				text: "Rasterelektronenmikroskopie (Motz, Betreuer: Dr. Michael Marx)",
			},
			{
				id: 4,
				text: "Diffusionspaare (Motz, Betreuer: Jonas Rauber)",
			},
			{
				id: 5,
				text: "Bruchmechanik  (Motz, Betreuer: Maike Jordt)",
			},
			{
				id: 6,
				text: "Werkstoffprüfung T1: Gießen von Metallen (Busch, Betreuer: Benedikt Schmidt)",
			},
			{
				id: 7,
				text: "Aushärtung von Aluminium (Busch, Betreuer: Maximilian Frey)",
			},
			{
				id: 8,
				text: "Ansteuerung eines Formgedächtnisdrahts mit NI LabVIEW (Seelecke, Betreuer: Daniel Bruch, Sebastian Gratz-Kelly)",
			},
			{
				id: 9,
				text: "Dichte, Volumen, Poren (Falk, Betreuer: Laura Krämer, Doris Ranker)",
			},
			{
				id: 10,
				text: "Untersuchungen zum weggeführten Honen (Bähre, Betreuer: Murat Güner)",
			},
			{
				id: 11,
				text: "Untersuchungen an der ECM-Anlage mittels Parameterstudie (Bähre, Betreuer: Thomas Hall)",
			},
		],
	},
	{
		id: 3,
		type: "text",
		items: [
			{
				id: 12,
				text: 'Gerne können Sie auch Lob und Kritik angeben. Insbesondere falls Sie "Sehr gut" oder "Mangelhaft" angekreuzt haben, würde uns der Grund interessieren:',
			},
		],
	},
];
